module.exports = __webpack_public_path__ + "img/icon-limit-usa.ae450346.svg";